import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/index.css';
import { ConfigErrorScreen } from '@/routes/ConfigErrorScreen';
import { ConfigError, loadConfig } from '@/lib/config';
import { createSupabaseClient } from '@/lib/supabase';
import { initPartnersI18n } from '@partners/i18n';
import { PartnersApp } from '@partners/PartnersApp';

/* The promoter portal's entry: the same runtime config.js and Supabase client as the portal, its own copy
 * (`promoter.*` only) and its own two routes. */
const root = createRoot(document.getElementById('root')!);

try {
  const config = loadConfig();
  initPartnersI18n(config.defaultLocale);
  const client = createSupabaseClient(config);
  root.render(
    <StrictMode>
      <PartnersApp client={client} />
    </StrictMode>,
  );
} catch (error) {
  if (!(error instanceof ConfigError)) throw error;
  root.render(<ConfigErrorScreen message={error.message} />);
}
